import { ReactComponent as TickIcon } from "components/icons/tick.svg";

import "./VerifiedTick.scss";

export const VerifiedTick = (props: {
  hint: string;
}): JSX.Element => {
  return (
    <div className="verifiedTick" title={props.hint}>
      <TickIcon />
    </div>
  );
};
